<template>
  <div>
    <v-btn
      color="primary"
      class="mb-2"
      text
      :disabled="disabled || loading"
      :loading="loading"
      style="height: 100%;width: 100%;border-radius: 10px;margin: 0 !important;"
      @click="open"
    >
      <v-icon>mdi-calendar-check</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="338px" persistent>
      <v-card>
        <v-card-title>
          <span>Escolha a data de instalação</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="draftDate"
            class="date-picker-height"
            locale="pt-br"
            type="month"
          ></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text :disabled="loading" @click="close">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :loading="loading"
            :disabled="!draftDate || loading"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "InstallationDateDialog",

  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    dialog: false,
    draftDate: null,
  }),

  methods: {
    open() {
      this.draftDate = this.value
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.draftDate = null
    },
    save() {
      this.$emit("save", this.draftDate)
      this.close()
    },
  },
}
</script>
